<template>
    <b-modal v-model="modalShow" ref="modal-transf-salesman" size="lg" title="Transferir Vendedor">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.team_id != ''}">
                        <label for="team_id" class="bmd-label-floating">Equipes <span class="text-danger">*</span></label>
                        <model-list-select 
                            class="form-control"
                            :list="teams"     
                            option-value="id"
                            option-text="name"
                            v-model="form.team_id"
                            @input="changeTeam">
                        </model-list-select>
                        <label v-if="validation.team_id != ''" id="team_id-error" class="error" for="team_id">{{ validation.team_id }}</label>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.salesman_id != ''}">
                        <label for="salesmans" class="bmd-label-floating">Vendedor <span class="text-danger">*</span></label>
                        <model-list-select 
                            class="form-control"
                            :list="salesmans"     
                            option-value="id"
                            option-text="name"
                            v-model="form.salesman_id">
                        </model-list-select>
                        <label v-if="validation.salesman_id != ''" id="salesman_id-error" class="error" for="salesman_id">{{ validation.salesman_id }}</label>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitTransfSalesman" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    import JwtService from '@/services/jwt.service';
    import UserService from '@/services/modules/users.service';

    export default {
        computed: {
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                },
                set(_teams) {

                }
            }
        },
        mounted() {
            var self = this;

            self.form.id = self.$route.params.id;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });

            self.getDataTeams();
        },
        data() {
            return {
                form: {
                    salesman_id: '',
                    team_id: ''
                },
                modalShow: true,
                salesmans: [],
                validation: {
                    salesman_id: '',
                    team_id: ''
                }
            };
        },
        methods: {
            changeTeam(_teamId) {
                this.getDataSalesmans(_teamId);
            },
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitTransfSalesman(_ev) {
                _ev.preventDefault();
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('proposals/edit', self.form);

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.success("Proposta transferida com sucesso!");
                    self.goBack();
                });

                response.catch(function (err) {
                    self.$root.$emit("onLoading");
                    if (err.status === 406 || err.status === 422) {
                        if (err.data.invoice_at !== undefined) {
                            self.validation.invoice_at = err.data.invoice_at[0];
                        }
                        if (err.data.observations !== undefined) {
                            self.validation.observations = err.data.observations[0];
                        }
                    }
                });
            },
            async getDataSalesmans(_teamId) {
                var self = this;

                self.$root.$emit("onLoading");

                var params = 'branch_id=' + JwtService.getBranchId()
                        //+ '&profile_id=' + UserService.typeProfiles.salesman
                        + '&team_id=' + _teamId;

                const response = UserService.all(params);

                response.then(function (_users) {
                    self.salesmans = _users;
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
        }
    };
</script>